import ReactQuill from "react-quill";
import backIcon from "@img/arrow.svg";
import { useEffect, useMemo, useState } from "react";

import { useAuth } from "@/utils/auth-context";
import whatsappIcon from "@img/whatsapp.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { useVideos } from "@/utils/video-context";
import { addCategoryToModules } from "@/utils/test";

const LessonModal = () => {
  const location = useLocation();
  const {
    moduleId,
    category,
    id,
    lessonContent,
    lessonUrl,
    secondUrl,
    allLessons,
  } = location.state;

  console.log(category, 'category')

  const allLessonsFlat = useMemo(() => {
    if (!allLessons || allLessons.length === 0) return [];

    return allLessons
      .filter(
        (module) => Array.isArray(module.videos) && module.videos.length > 0
      )
      .flatMap((module) =>
        module.videos.map((lesson) => ({
          ...lesson,
          uniqueId: `${module.id}-${lesson.id}`,
          moduleId: module.id,
        }))
      );
  }, [allLessons]);

  console.log(allLessonsFlat, "all");

  const currentIndex = allLessonsFlat.findIndex(
    (lesson) => lesson.uniqueId === `${moduleId}-${id}`
  );

  console.log(currentIndex, "cuurent");
  const currentLesson = allLessonsFlat[currentIndex];

  const goToPrevious = () => {
    if (currentIndex > 0) {
      const prevLesson = allLessonsFlat[currentIndex - 1];
      navigate(`/course/${category}/${prevLesson.id}`, {
        state: {
          category: prevLesson.category,
          id: prevLesson.id,
          lessonContent: prevLesson.content,
          lessonUrl: prevLesson.videoURL,
          secondUrl: prevLesson.url,
          allLessons,
          moduleId: prevLesson.moduleId,
        },
      });
    }
  };

  const goToNext = () => {
    if (currentIndex < allLessonsFlat.length - 1) {
      const nextLesson = allLessonsFlat[currentIndex + 1];
      navigate(`/course/${category}/${nextLesson.id}`, {
        state: {
          category: nextLesson.category,
          id: nextLesson.id,
          lessonContent: nextLesson.content,
          lessonUrl: nextLesson.videoURL,
          secondUrl: nextLesson.url,
          allLessons,
          moduleId: nextLesson.moduleId,
        },
      });
    }
  };

  const [isLoaded, setIsLoaded] = useState(false);
  const [isVimeoPlayer, setIsVimeoPlayer] = useState(true);
  const [isSecondPlayerLoaded, setIsSecondPlayerLoaded] = useState(false);
  const { isVerified } = useAuth();

  const handlePlayerToggle = () => {
    setIsVimeoPlayer((prevState) => !prevState); // Toggle between players
  };

  const handleOpenWhatsapp = () => {
    const url = `https://wa.me/77770430340?cacheBuster=${Date.now()}`;
    window.open(url, "_blank");
  };

  const navigate = useNavigate();

  return (
    <div className={`layout`}>
      <div className={`lessons`}>
        <button
          className={`button-navigation`}
          onClick={() => navigate(`/course/${category}`)}
        >
          <img width={30} src={backIcon} alt={`back-icon`} /> Вернуться к урокам
        </button>
        <div className="button-navigation-box">
          <button className={`button-navigation`} onClick={goToPrevious}>
            <img width={30} src={backIcon} alt={`back-icon`} />
          </button>
          <button className={`button-navigation`} onClick={goToNext}>
            <img
              className="button-img-next"
              width={30}
              src={backIcon}
              alt={`back-icon`}
            />{" "}
          </button>
        </div>
        {lessonUrl && isVimeoPlayer && (
          <div className="lesson-modal-content__video">
            {!isLoaded && (
              <div className="video-placeholder">Загрузка видео...</div>
            )}

            <iframe
              style={{ border: "none" }}
              src={`https://player.vimeo.com/video/${lessonUrl}?title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479`}
              allow="fullscreen; picture-in-picture; clipboard-write; encrypted-media"
              loading="lazy"
              onLoad={() => setIsLoaded(true)}
            ></iframe>
          </div>
        )}

        {secondUrl && !isVimeoPlayer && (
          <div className="lesson-modal-content__video">
            {!isSecondPlayerLoaded && (
              <div className="video-placeholder">Загрузка видео...</div>
            )}
            <iframe
              style={{ border: "none" }}
              src={secondUrl} // You can replace this with your fallback player's URL format
              allow="fullscreen; picture-in-picture; clipboard-write; encrypted-media"
              loading="lazy"
              onLoad={() => setIsSecondPlayerLoaded(true)}
            ></iframe>
          </div>
        )}

        {lessonUrl && (
          <button
            onClick={handlePlayerToggle}
            className="lesson-modal-content__toggleBtn"
          >
            <span className="lesson-modal-content__toggleBtn__icon"> ! </span>
            {isVimeoPlayer
              ? "Видео не загружается? Переключиться на другой плеер"
              : "Вернуться к основному плееру"}
          </button>
        )}

        {!isVerified && lessonUrl && (
          <button
            onClick={handleOpenWhatsapp}
            className="button-navigation button-whatsapp"
          >
            <img width={25} src={whatsappIcon}></img> Написать на WhatsApp{" "}
          </button>
        )}

        {lessonContent && (
          <ReactQuill
            value={lessonContent}
            readOnly
            theme="snow"
            modules={{
              toolbar: false,
            }}
            className="lesson-modal-content__text"
          />
        )}
      </div>
    </div>
  );
};

export default LessonModal;
